export var easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    // Objects leave the screen at full velocity.
    easeIn: 'cubic-bezier(0.4, 0.0, 1, 1)',
    // The sharp curve is used  may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
};
export var duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195,
};
export var formatMs = function (miliseconds) { return Math.round(miliseconds) + "ms"; };
/**
 * 创建css3变换表达式
 *
 * @param props css3变换属性，可以是1个或者多个
 * @param options css3变换配置
 */
function createTransition(props, options) {
    if (props === void 0) { props = ['all']; }
    if (options === void 0) { options = {}; }
    var _a = options.duration, durationOption = _a === void 0 ? duration.standard : _a, _b = options.easing, easingOption = _b === void 0 ? easing.easeInOut : _b, _c = options.delay, delay = _c === void 0 ? 0 : _c;
    return (Array.isArray(props) ? props : [props])
        .map(function (animatedProp) {
        return animatedProp + " " + formatMs(durationOption) + " " + easingOption + " " + formatMs(delay);
    })
        .join(',');
}
/**
 * 根据高度获取动画时长
 *
 * @param height 高度
 */
function getAutoHeightDuration(height) {
    if (!height) {
        return 0;
    }
    var constant = height / 36;
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
var transitions = {
    easing: easing,
    duration: duration,
    create: createTransition,
    getAutoHeightDuration: getAutoHeightDuration,
};
export default transitions;
//# sourceMappingURL=transitions.js.map